import classnames from 'classnames';

import style from './Border.module.scss';

export interface BorderProps {
    withoutMarginBottom?: boolean;
}

interface Props extends BorderProps {}

export function Border({ withoutMarginBottom }: Props) {
    return <div className={classnames([style.root, withoutMarginBottom && style.root_withoutMarginBottom])} />;
}
